import {
  Document,
  PDFViewer,
  Page as PDFPage,
  StyleSheet,
  Text as PDFText,
  View as PDFView,
  Image as PDFImage,
  Font
} from '@react-pdf/renderer';
import { dateFormatter, request } from '../../../../../utils';
import parse from 'html-react-parser';
import { BASE_URL_FOR_FILE } from '../../../../../utils/BaseUrl';
import { useEffect, useState } from 'react';


import React from "react";
import JsBarcode from "jsbarcode";
import QRCode from "qrcode";

// EXACT FONT REGISTRATION AS PREVIOUS WORKING COMPONENT
Font.register({
  family: 'Roboto',
  fonts: [{ src: '/Roboto-Bold.ttf', fontWeight: 'bold' }]
});

Font.register({
  family: 'Roboto2',
  fonts: [{ src: '/Roboto-Medium.ttf' }]
});
Font.register({
  family: 'Noto',
  fonts: [
    { src: '/NotoSans-Regular.ttf' },
    { src: '/NotoSans-Bold.ttf', fontWeight: 'bold' }
  ]
});


const styles = StyleSheet.create({
  page: {
    padding: 20
  },
  heading: {
    fontSize: 18,
    textAlign: 'center',
    marginBottom: 20
  },
  line: {
    height: 0.6,
    backgroundColor: 'black',
    marginVertical: 10,
    marginTop: '40px'
  },
  line2: {
    height: 0.4,
    backgroundColor: 'black',
    marginVertical: 10
  },
  contentContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 0,
    marginBottom: 0,
    border: '1px Solid gray',
    padding: '10px',
    borderRadius: '8px'
  },
  contentContainer2: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    marginTop: 10,
    marginBottom: 0
  },
  column: {
    flex: 1,
    paddingHorizontal: 10
  },
  row: {
    flexDirection: 'row',
    marginBottom: 5
  },
  row2: {
    flexDirection: 'row'
  },
  text: {
    fontSize: 9,
    display: 'inline-block',
    textAlign: 'start'
  },
  textBold: {
    fontSize: 9,
    fontWeight: 'bold'
  },
  textUnderlined: {
    textDecoration: 'underline'
  },
  columnContent: {
    width: '25%',
    textAlign: 'center',
    alignItems: 'center',
    paddingLeft: '10%'
  },
  columnHeader: {
    width: '15%',
    borderTop: '0.8px solid black',
    borderBottom: '0.8px solid black',
    color: 'black',
    padding: 5,
    textAlign: 'center',
    marginTop: '2%'
  },
  boldText: {
    fontFamily: 'Roboto',
    fontSize: 6,
    fontSize: '10px',
    marginTop: '1%',
    marginLeft: '4%'
  },
  bText: {
    fontFamily: 'Roboto',
    fontWeight: 'bold',
    fontSize: '10px'
  },
  ResultEntryText: {
    fontFamily: 'Roboto',
    fontSize: '12px',
    margin: '0 auto',
    fontWeight: 'ultrabold'
  },
  fontBold: {
    width: '25%',
    paddingLeft: '10%',
    fontFamily: 'Roboto',
    fontWeight: 'ultrabold',
    textDecoration: 'underline'
  },
  parsedContent: {
    marginTop: 10,
    fontSize: 10,
    textAlign: 'justify',
    padding: 10
  },
  imageStyle: {
    width: '10%',
    height: 80
  },
  table: {
    display: 'table',
    width: '100%',
    marginTop: 10
  },
  tableRow: {
    display: 'flex',
    flexDirection: 'row'
  },
  tableCell: {
    display: 'flex',
    width: '50%',
    padding: 5,
    border: '0.6px solid black'
  },
  testGroupHeader: {
    fontSize: '14px',
    fontFamily: 'Roboto',
    textAlign: 'center',
    marginTop: '3%',
    marginBottom: '2%',
    backgroundColor: '#f0f0f0',
    padding: '5px',
    borderRadius: '4px'
  },
  parameterGroupHeader: {
    fontSize: '11px',
    fontFamily: 'Roboto',
    marginTop: '10px',
    marginBottom: '5px',
    textAlign: 'start',
    paddingLeft: '10px',
    backgroundColor: '#e8e8e8',
    padding: '3px',
    borderRadius: '3px'
  }
});




const Page = ({ style, children, ...props }) => (
  <PDFPage style={{ ...styles.page, ...style }} {...props}>
    {children}
  </PDFPage>
);

const View = ({ style, children, ...props }) => (
  <PDFView style={{ ...style }} {...props}>
    {children}
  </PDFView>
);

const Text = ({ style, content, ...props }) => (
  <PDFText style={{ ...styles.text, ...style }} {...props}>
    {content}
  </PDFText>
);

const COLORS = ['#f0f0f0', '#e0e0e0'];

export const ResultEntryPdf = ({ data }) => {
  const [imagePreview, setImagePreview] = useState([]);

  const [barcodeImg, setBarcodeImg] = React.useState('');
  const [qrImg, setQrImg] = React.useState('');

  React.useEffect(() => {
    // BARCODE
    const canvas = document.createElement("canvas");
    JsBarcode(canvas, data.receiptNo, {
      format: "CODE128",
      displayValue: false,
      height: 40,
      margin: 0
    });
    setBarcodeImg(canvas.toDataURL("image/png"));

    // QR CODE (Full page URL)
    const fullUrl = window.location.href;
    QRCode.toDataURL(fullUrl).then((url) => {
      setQrImg(url);
    });

  }, [data]);

  const parseHtmlToPdfText = (html) => {
    return parse(html, {
      replace: (domNode) => {
        if (domNode.type === 'tag') {
          switch (domNode.name) {
            case 'strong':
              return (
                <PDFText style={styles.boldText}>
                  {domNode.children.map((child) => child.data).join('')}
                </PDFText>
              );
            case 'p':
              return (
                <PDFText style={styles.text}>
                  {domNode.children
                    .map((child) => {
                      if (child.type === 'text') {
                        return child.data.trim();
                      }
                      if (child.type === 'tag' && child.name === 'strong') {
                        return child.children.map((strongChild) => strongChild.data).join('');
                      }
                      return '';
                    })
                    .join(' ')}
                </PDFText>
              );
            default:
              return <PDFText style={styles.text}>{domNode.data}</PDFText>;
          }
        }
      }
    });
  };

  const stripHtml = (html) => {
    return html.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ');
  };

  const editorContentPlainText = stripHtml(data?.editorContent || '');

  // Helper function for row background color - EXACTLY SAME AS PREVIOUS
  const getRowBackgroundColorForPDF = (parameter, index) => {
    const resultValue = parseFloat(parameter?.value);
    const referenceRange = parameter?.reference_range;

    if (!referenceRange || !resultValue) {
      return index % 2 ? 'lightgrey' : 'transparent';
    }

    // Extract numbers from reference range (format: "X - Y")
    const rangeNumbers = referenceRange.match(/\d+\.?\d*/g);
    if (!rangeNumbers || rangeNumbers.length < 2) {
      return index % 2 ? 'lightgrey' : 'transparent';
    }

    const from = parseFloat(rangeNumbers[0]);
    const to = parseFloat(rangeNumbers[1]);

    if (isNaN(resultValue) || (from === 0 && to === 0)) {
      return index % 2 ? 'lightgrey' : 'transparent';
    }

    const lowerMargin = from * 0.1;
    const upperMargin = to * 0.1;

    const lowerOrangeLimit = from - lowerMargin;
    const upperOrangeLimit = to + upperMargin;

    if (resultValue < lowerOrangeLimit || resultValue > upperOrangeLimit) {
      return '#FFCDD2'; // 🔴 Red
    }

    if (
      (resultValue >= lowerOrangeLimit && resultValue < from) ||
      (resultValue > to && resultValue <= upperOrangeLimit)
    ) {
      return '#FFE0B2'; // 🟠 Orange
    }

    return index % 2 ? 'lightgrey' : 'transparent'; // zebra striping
  };

  // Helper function to get status indicator - SIMPLIFIED LIKE PREVIOUS
  const getStatusIndicator = (parameter) => {
    const resultValue = parseFloat(parameter?.value);
    const referenceRange = parameter?.reference_range;

    if (!referenceRange || !resultValue) return '';

    const rangeNumbers = referenceRange.match(/\d+\.?\d*/g);
    if (!rangeNumbers || rangeNumbers.length < 2) return '';

    const from = parseFloat(rangeNumbers[0]);
    const to = parseFloat(rangeNumbers[1]);

    if (resultValue > to) return 'H';
    if (resultValue < from) return 'L';
    return '';
  };

  const fetchLabAuthorityDoctor = async () => {
    const response = await request('/lab-authority-doctor-list', { method: 'GET' });
    if (response.success) {
      const datas = response?.data;
      const filteredData = datas.filter((item) => item._id === data.footer?.verified_for_doctor);
      setImagePreview(filteredData);
    } else {
      console.log('Error');
    }
  };

  useEffect(() => {
    if (data?.footer?.verified_for_doctor) {
      fetchLabAuthorityDoctor();
    }
  }, [data]);

  return (
    <PDFViewer width="100%" height="100%" showToolbar>
      <Document title={`Result Entry - ${data?.header?.report_id}`}>
        <Page size="A4" style={styles.page}>
          {/* Header with Hospital Logo - EXACTLY SAME AS PREVIOUS */}
          <PDFImage
            src="/logo_lab_Hospital_m.jpeg"
            style={{ width: '100%', height: '80px', marginBottom: 10 }}
             fixed
          />


          <View style={{ flexDirection: "row", justifyContent: "space-between", marginTop: 12, marginBottom: 2 }}>
            {barcodeImg && (
              <PDFImage
                src={barcodeImg}
                style={{ width: 130, height: 40 }}
              />
            )}

            {qrImg && (
              <PDFImage
                src={qrImg}
                style={{ width: 70, height: 70 }}
              />
            )}
          </View>

          {/* Patient Information - EXACTLY SAME STRUCTURE AS PREVIOUS */}
          <View style={styles.contentContainer}>
            <View style={{ ...styles.column, marginLeft: '1%' }}>
              <View style={styles.row}>
                <Text content="Name               :      " style={styles.bText} />
                <Text style={{ fontSize: '11px' }} content={`${data?.patient?.name || '-'}`} />
              </View>
              <View style={styles.row}>
                <Text content="Age/Gender    :      " style={styles.bText} />
                <Text style={{ fontSize: '11px' }} content={`${data?.patient?.age || '-'}Yrs/${data?.patient?.gender || '-'}`} />
              </View>
              <View style={styles.row}>
                <Text content="Phone No.       :      " style={styles.bText} />
                <Text style={{ fontSize: '11px' }} content={`${data?.patient?.mobile || '-'}`} />
              </View>
              <View style={styles.row}>
                <Text content="Report Date    :      " style={styles.bText} />
                <Text style={{ fontSize: '11px' }} content={`${data?.formatted_dates?.report_date || dateFormatter(data?.header?.report_date)}`} />
              </View>
            </View>

            <View style={styles.column}>
              <View style={styles.row}>
                <Text content="UHID                       :      " style={styles.bText} />
                <Text style={{ fontSize: '11px' }} content={`${data?.patient?.uhid || '-'}`} />
              </View>
              <View style={styles.row}>
                <Text content="Report Id                :     " style={styles.bText} />
                <Text style={{ fontSize: '11px' }} content={`${data?.header?.report_id || '-'}`} />
              </View>
              <View style={styles.row}>
                <Text content="Collection Date     :     " style={styles.bText} />
                <Text style={{ fontSize: '11px' }} content={`${data?.formatted_dates?.collection_date || dateFormatter(data?.collection?.sample_collected)}`} />
              </View>
              <View style={styles.row}>
                <Text content="Doctor Advised     :     " style={styles.bText} />
                <Text style={{ fontSize: '11px' }} content={data?.doctor?.name || '-'} />
              </View>
            </View>
          </View>

          {/* Test Results - USING EXACT SAME APPROACH AS PREVIOUS */}
          {data?.tests?.map((test, testIndex) => (
            <View key={testIndex} style={{ width: '100%' }}>
              <Text
                style={{
                  width: '100%',
                  textAlign: 'center',
                  fontSize: '14px',
                  fontFamily: 'Roboto',
                  marginTop: '1%'
                }}
                content={test.test_name}
              />

              {/* Table Headers - EXACTLY SAME STRUCTURE AS PREVIOUS */}
              <View style={{ ...styles.row2, width: '100%', flexDirection: 'row' }}>
                <Text
                  style={{
                    ...styles.columnHeader,
                    width: '40%',
                    fontSize: '12px',
                    fontFamily: 'Roboto',
                    textAlign: 'start'
                  }}
                  content="Investigation"
                />
                <Text
                  style={{ ...styles.columnHeader, width: '15%', fontSize: '12px', fontFamily: 'Roboto' }}
                  content="Result"
                />
                <Text
                  style={{ ...styles.columnHeader, width: '10%', fontSize: '12px', fontFamily: 'Roboto' }}
                  content=""
                />
                <Text
                  style={{ ...styles.columnHeader, width: '25%', fontSize: '12px', fontFamily: 'Roboto' }}
                  content="Reference Value"
                />
                <Text
                  style={{ ...styles.columnHeader, width: '10%', fontSize: '12px', fontFamily: 'Roboto' }}
                  content="Unit"
                />
              </View>

              {/* Parameter Groups */}
              {test.results?.map((group, groupIndex) => (
                <View key={groupIndex} style={{ marginBottom: '5px' }}>
                  <Text
                    style={{
                      fontSize: '11px',
                      fontFamily: 'Roboto',
                      marginTop: '5px',
                      marginBottom: '2px',
                      textAlign: 'center',
                      fontWeight: 'bold',
                      textAlign: 'start'
                    }}
                    content={group.group_name}
                  />

                  {group.parameters?.map((parameter, paramIndex) => (
                    <View
                      key={paramIndex}
                      style={{
                        flexDirection: 'row',
                        backgroundColor: getRowBackgroundColorForPDF(parameter, paramIndex),
                        alignItems: 'flex-start'
                      }}
                    >
                      {/* Parameter Name */}
                      <View style={{ width: '40%' }}>
                        <Text
                          content={parameter.parameter_name || '-'}
                          style={{
                            textAlign: 'start',
                            fontSize: '9px',
                            marginLeft: '15px',
                            fontFamily: 'Roboto2'
                          }}
                          wrap
                        />
                      </View>

                      {/* Result Value */}
                      <Text
                        content={parameter.value || parameter.display_value || '-'}
                        style={{
                          width: '15%',
                          textAlign: 'center',
                          fontSize: '9px',
                          fontFamily: getStatusIndicator(parameter) ? 'Roboto' : 'Roboto2'
                        }}
                        wrap
                      />

                      {/* Status Indicator */}
                      <Text
                        content={getStatusIndicator(parameter)}
                        style={{
                          width: '10%',
                          textAlign: 'center',
                          fontSize: '9px',
                          fontFamily: 'Roboto'
                        }}
                        wrap
                      />

                      {/* Reference Range */}
                      <Text
                        content={parameter.reference_range || '-'}
                        style={{
                          width: '25%',
                          textAlign: 'center',
                          fontSize: '9px',
                           fontFamily: 'Noto'
                        }}
                        wrap
                      />

                      {/* Unit */}
                      <Text
                        content={parameter.unit || '-'}
                        style={{
                          width: '10%',
                          textAlign: 'center',
                          fontSize: '9px',
                           fontFamily: 'Noto'
                        }}
                        wrap
                      />
                    </View>
                  ))}
                </View>
              ))}
            </View>
          ))}

          {/* Footer Section - EXACTLY SAME AS PREVIOUS */}
          <View
            style={{
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              padding: 20,
              marginTop: '5%',
              borderTop: '1px solid #d3d3d3',
              borderBottom: '1px solid #d3d3d3'
            }}
          >
            <View style={{ marginBottom: 10, width: '100%' }}>
              <Text
                style={{ fontSize: 10, textAlign: 'start', color: 'black', fontFamily: 'Roboto2' }}
                content={'Thanks For Reference'}
              />
              <Text
                content={'*******End OF Report********'}
                style={{ fontSize: 9, textAlign: 'center', color: 'black', fontFamily: 'Roboto' }}
              />
            </View>

            {/* Doctor Signature - EXACTLY SAME AS PREVIOUS */}
            <View style={{ flexDirection: 'row', justifyContent: 'flex-end', alignItems: 'flex-end', width: '100%' }}>
              {imagePreview && imagePreview[0]?.signature && (
                <View style={{ alignItems: 'center' }}>
                  <PDFImage
                    src={`${imagePreview[0]?.signatureBase64}`}
                    style={{ width: 50, height: 50, marginBottom: 5 }}
                  />
                  <Text
                    style={{ fontSize: 11, textAlign: 'center', color: 'black' }}
                    content={imagePreview[0]?.doctor}
                  />
                  <Text
                    style={{ fontSize: 11, textAlign: 'center', color: 'black' }}
                    content={imagePreview[0]?.heading_1 || ''}
                  />
                  <Text
                    style={{ fontSize: 11, textAlign: 'center', color: 'black' }}
                    content={imagePreview[0]?.heading_2 || ''}
                  />
                  <Text
                    style={{ fontSize: 11, textAlign: 'center', color: 'black' }}
                    content={imagePreview[0]?.heading_3 || ''}
                  />
                </View>
              )}
            </View>
          </View>
        </Page>
      </Document>
    </PDFViewer>
  );
};